import * as React from 'react';
import RadioButton from "../../../hiberUiKit/src/atoms/RadioButton/RadioButton";

const uuidv4 = require('uuid/v4');

export interface RadioButtonOption {
	/**
	 * Label for radio button.
	 */
	label: string;
	/**
	 * Radio button value.
	 */
	value: string;
	/**
	 * Radio button disable flag.
	 */
	disabled: boolean;
}

interface Props {
	/**
	 * Radio button options list.
	 */
	radioButtonOptions: RadioButtonOption[];
	/**
	 * On change callback.
	 * @param {string} value
	 */
	onChange: (value: string) => void;
	/**
	 * Value of selected element.
	 */
	selected: string;
}

export default class InlineRadioButtons extends React.Component<Props, {}> {

	/**
	 * Unique radios name.
	 */
	inputRadiosName = uuidv4();

	/**
	 * Hot keys map.
	 */
	hotKeysMap = {
		onEnter: 'enter'
	};

	/**
	 * Hot keys handlers
	 */
	hotKeysHandlers: any;

	constructor(props: Props) {
		super(props);
		this.hotKeysHandlers = {
			onEnter: () => this.props.onChange(this.props.selected)
		}
	}

	render() {
		return (
			<div className="m-radio-inline">
				{this.props.radioButtonOptions.map((option, index) => this.renderRadio(option, index))}
			</div>
		);
	}

	/**
	 * Renders single radio button.
	 * @param {RadioButtonOption} option Radio button option.
	 * @param {number} index Map index.
	 */
	renderRadio(option: RadioButtonOption, index: number): JSX.Element {
		return (
			<span style={{float: "left", marginRight: 10}} key={index}>
				<RadioButton radioButtonOption={option}
							 onChange={value => option.disabled ? () => {} : this.props.onChange(value)}
							 selected={this.props.selected == option.value}/>
			</span>
		);
	}
}